// extracted by mini-css-extract-plugin
export default {"Grid":"Grid-module--Grid--kkTMn","centered":"Grid-module--centered--F+Rpl"};